import {AnalyticsProvider} from '@github-ui/analytics-provider'
import {PageBanner} from '@github-ui/custom-properties-core/components/PageBanner'
import {BannerProvider} from '@github-ui/custom-properties-core/context/BannerContext'
import type {PropsWithChildren} from 'react'

const metadata = {}

export function App({children}: PropsWithChildren) {
  return (
    <AnalyticsProvider appName="repo-custom-properties" category="" metadata={metadata}>
      <BannerProvider>
        <PageBanner className="tmp-mb-3" />
        {children}
      </BannerProvider>
    </AnalyticsProvider>
  )
}
